module.exports = __webpack_public_path__ + "img/coupon.232163bb.png";